import type { ReactElement, ReactNode } from "react";
import { Icon } from "../Icon/Icon";
import type { IconName } from "../../lib/navigation";
import styles from "./Alert.module.css";

export type AlertTone = "success" | "warning" | "danger" | "info";

export interface AlertProps {
  tone: AlertTone;
  title?: string;
  children?: ReactNode;
  action?: ReactNode;
}

const TONE_ICON: Record<AlertTone, IconName> = {
  success: "check",
  warning: "alert",
  danger: "alert",
  info: "info",
};

export function Alert({
  tone,
  title,
  children,
  action,
}: AlertProps): ReactElement {
  const assertive = tone === "danger" || tone === "warning";
  return (
    <div
      className={`${styles.alert} ${styles[tone]}`}
      role={assertive ? "alert" : "status"}
    >
      <span className={styles.icon}>
        <Icon name={TONE_ICON[tone]} />
      </span>
      <div className={styles.body}>
        {title ? <p className={styles.title}>{title}</p> : null}
        {children ? <div className={styles.text}>{children}</div> : null}
      </div>
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  );
}
